export default "__VITE_ASSET__27e28a8f__"